<template>
    <figure class="b-zdfplayer zdfplayer_ zdfplayer_core/Player"></figure>
</template>

<script>
    // Doku zum Abspielen von Medien, die nicht aus der Mediathek kommen
    // http://online-guidelines.zdf.de/videoplayer/manuelle-assets/

    import EventBus from "../tools/event-bus";

    function initPlayer()
    {
        if (window.zdfplayer)
        {
            window.zdfplayer.applyBehaviour(window.document);

            window.zdfplayer.on('Player::PAUSED', function ()
            {
                //console.log('zdfplayer.PAUSED');
                EventBus.$emit('video.stopped');
            });
            window.zdfplayer.on('Player::PLAYING', () =>
            {
                //console.log('zdfplayer.PLAYING');
                EventBus.$emit('video.playing');
            });
            window.zdfplayer.on('Player::STOPPED', () =>
            {
                //console.log('zdfplayer.STOPPED');
                EventBus.$emit('video.stopped');
            });
            window.zdfplayer.on('Player::FINISHED', () =>
            {
                //console.log('zdfplayer.FINISHED');
                EventBus.$emit('video.stopped');
            });
        }
    }

    export default {
        name: "ZDFPlayer",
        props: ['modalName', 'video'],
        mounted()
        {
            // ZDF Video Player einfügen und initialisieren
            if (!document.getElementById('zdfplayer_script'))
            {
                // CSS <link rel="stylesheet" href="https://www.zdf.de/ZDFplayer/latest-v2/skins/zdf/zdf-player.css" type="text/css">
                var css = document.createElement("link");
                css.type = "text/css";
                css.rel = "stylesheet";
                css.href = "https://www.zdf.de/ZDFplayer/latest-v2/skins/zdf/zdf-player.css";
                document.head.appendChild(css);

                // Script <script src="https://www.zdf.de/ZDFplayer/latest-v2/skins/zdf/zdf-player.js" type="text/javascript"...
                var script = document.createElement("script");
                script.type = "text/javascript";
                script.id = "zdfplayer_script";
                script.src = "https://www.zdf.de/ZDFplayer/latest-v2/skins/zdf/zdf-player.js";
                script.onload = () =>
                {
                    initPlayer();
                };
                document.head.appendChild(script);
            }
            else
            {
                // schon vorhanden, nur initialisieren
                initPlayer();
            }

            // Wenn die InfoBox geschlossen wird, pausieren wir den Player
            this.$eventBus.$on('InfoBox.show', (value) =>
            {
                if (value === false && window.zdfplayer)
                {
                    window.zdfplayer.fireEvent('Player::PAUSE'); // , {id: 'zdfplayer1'}
                }
            });
        }
    }
</script>

<style scoped lang="scss">

    //@import "../assets/scss/variables";

    figure {
        margin-bottom: 1rem;
    }

    /*
    figure,
    video {
        margin-bottom: 1rem;
    }

    figure {
        position: relative;
    }
    figcaption {
        position: absolute;
        transform: rotate(-90deg) translateY(-100%);
        transform-origin: 0 0;
        color: $gray;
        font-size: .8rem;
        padding: .25em 0;
    }
    */

</style>